.formFieldContainer {
    margin: 0px 10px 20px 0px;
    flex: 1;
}

.formReviewContainer {
    display: flex;
    justify-content: space-between;
    flex: 1;
    margin: 0px;
    gap: 20px;
}

.buttonContainer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-right: 10px;
}

.formRoleContainer {
    display: flex;
    gap: 20px;
}

/* This surrounds the badge so when it appears and disappears, the page doesn't jump. */
.badgeContainer {
    height: 25px;
}
